export default "__VITE_ASSET__CEZvob6T__"